/* Successful Shopify enquiries only. No customer field values are collected. */
(function () {
  'use strict';
  var key = 'tempo.enquiry.pending.v1';
  var serviceKey = 'tempo.enquiry.service.v1';
  var maxAge = 60 * 60 * 1000;
  var dispatched = false;
  var privacyRequested = false;
  function status(value) {
    document.querySelectorAll('[data-tempo-enquiry-context]').forEach(function (marker) { marker.setAttribute('data-tracking-status', value); });
  }
  function read(k) { try { return JSON.parse(sessionStorage.getItem(k)); } catch (_) { return null; } }
  function write(k, v) { try { sessionStorage.setItem(k, JSON.stringify(v)); return true; } catch (_) { return false; } }
  function remove(k) { try { sessionStorage.removeItem(k); } catch (_) {} }
  function allowed() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    return !!(privacy && privacy.analyticsProcessingAllowed && privacy.analyticsProcessingAllowed());
  }
  function fresh(value) { return value && Date.now() - value.time >= 0 && Date.now() - value.time < maxAge; }
  function cleanPath(path) { return /^\/[a-zA-Z0-9_\-/]*$/.test(path || '') ? path : ''; }
  function context(marker) {
    var handle = marker.getAttribute('data-service-handle') || '';
    return { handle: /^[a-z0-9-]+$/.test(handle) ? handle : '', page: cleanPath(marker.getAttribute('data-page-path')), time: Date.now() };
  }
  function rememberService() {
    if (!window.Shopify || !window.Shopify.customerPrivacy) return;
    if (!allowed()) { remove(key); remove(serviceKey); return; }
    document.querySelectorAll('[data-tempo-enquiry-context]').forEach(function (marker) {
      var current = context(marker);
      if (current.handle && current.handle !== 'contact-us') write(serviceKey, current);
    });
  }
  function sendSuccess() {
    if (dispatched || !allowed()) return;
    var pending = read(key);
    if (!fresh(pending)) { remove(key); return; }
    var success = Array.from(document.querySelectorAll('[data-tempo-enquiry-context][data-success="true"]')).some(function (marker) {
      var form = marker.closest('form');
      return form && form.id === pending.form_id && cleanPath(marker.getAttribute('data-page-path')) === pending.enquiry_page;
    });
    if (!success || typeof window.gtag !== 'function') return;
    /* Consume before dispatch, preventing refresh/back/repeated initialization duplicates. */
    remove(key);
    dispatched = true;
    var params = {
      send_to: 'G-S2XL2TVV0W',
      form_id: pending.form_id,
      service_handle: pending.service_handle,
      service_page: pending.service_page,
      enquiry_page: pending.enquiry_page,
      is_test: pending.is_test,
      transport_type: 'beacon'
    };
    if (pending.is_test === 'true') params.debug_mode = true;
    window.gtag('event', 'generate_lead', params);
  }
  document.addEventListener('submit', function (event) {
    var form = event.target;
    var marker = form.querySelector && form.querySelector('[data-tempo-enquiry-context]');
    if (!marker || !allowed()) return;
    var current = context(marker);
    var previous = read(serviceKey);
    var service = current.handle && current.handle !== 'contact-us' ? current : (fresh(previous) ? previous : null);
    write(key, {
      time: Date.now(), form_id: form.id,
      service_handle: service ? service.handle : 'direct-enquiry',
      service_page: service ? service.page : '(direct enquiry)',
      enquiry_page: current.page,
      is_test: new URLSearchParams(window.location.search).get('tempo_tracking_test') === '1' ? 'true' : 'false'
    });
  }, true);
  function start() {
    if (window.Shopify && !window.Shopify.customerPrivacy && window.Shopify.loadFeatures && !privacyRequested) {
      privacyRequested = true;
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], function (error) { if (!error) start(); });
    }
    if (!dispatched) status(allowed() ? 'ready' : 'awaiting-consent');
    rememberService(); sendSuccess();
    if (dispatched) status('event-dispatched');
  }
  document.addEventListener('visitorConsentCollected', start);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  /* The Google tag and Shopify consent API can load after the theme. */
  var attempts = 0;
  var timer = window.setInterval(function () { start(); if (++attempts >= 30 || dispatched) window.clearInterval(timer); }, 1000);
}());
